import React, { useEffect, useMemo, useState } from 'react'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import { getPortsForVm } from 'openstack/components/networks/actions'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function UsedFloatingIpsPicklist({
  disabled = false,
  name = 'fixedIp',
  label = 'Private IP',
  vmId,
  ...rest
}) {
  const [vmPorts, setVmPorts] = useState([])
  const [loadingVmPorts, setLoadingVmPorts] = useState(true)

  useEffect(() => {
    if (!vmId) {
      return
    }
    const getPorts = async () => {
      try {
        const response = await getPortsForVm({ vmId })
        setVmPorts(response)
      } catch (e) {
        console.log(e)
      } finally {
        setLoadingVmPorts(false)
      }
    }
    getPorts()
  }, [vmId])

  const options = useMemo(() => {
    return vmPorts.map((port) => {
      // For Layer2 networks, fixed_ips is not available so we use port name or id as label
      const ipAddressString =
        port.fixed_ips?.map((ip) => ip.ip_address)?.join(', ') || port?.name || port?.id
      return {
        label: ipAddressString,
        value: port.id,
      }
    })
  }, [vmPorts])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loadingVmPorts}
      items={options}
    />
  )
}
